import { getAssetDomainByMPGlobals } from 'lib/deployment'

export default [
  {
    title: 'Boddle',
    url: `https://delivers.dtignite.com/v2/delivers/clickAd.jsp?siteId=12733&campaignId=39726&tsti=false&triggerSource=delivers`,
    starCount: '4.5',
    // @todo Why the different domain? --hrivera
    image: `https://images.cm.digitalturbine.com/static/4a806e59ca8e594925d6a1f58099dd7c1ba3116f59a5d15e49062c0965abf7de.webp`
  },
  {
    title: `Active Armor`,
    url: `https://delivers.dtignite.com/v2/delivers/clickAd.jsp?siteId=12733&campaignId=36198`,
    starCount: '4.5',
    // @todo Why the different domain? --hrivera
    image: `https://images.cm.digitalturbine.com/2fc3913dc6ce10dec81187581767bc647380b17c28a42e9cb019ca8e5d785bf8.webp`
  },
  {
    title: 'GEForce NOW',
    url: `https://delivers.dtignite.com/v2/delivers/clickAd.jsp?siteId=12733&campaignId=37654&tsti=false&triggerSource=delivers`,
    starCount: '4.5',
    // @todo Why the different domain? --hrivera
    image: `https://play-lh.googleusercontent.com/e0vSuE4NmtqBRhVYUXvQTFik4XS4xST6RADwN_bFFG20OxwtIXndeA9wPaky0910wgw=s72-rw`
  },
  {
    title: 'Tile Master',
    url: `https://play.google.com/store/apps/details?id=com.tilemaster.puzzle.block.match`,
    starCount: '4.5',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-tile-master-app-logo.webp`
  },
  {
    title: 'Subway Surfers',
    url: `https://play.google.com/store/apps/details?id=com.kiloo.subwaysurf`,
    starCount: '4.5',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-subway-surfers-app-logo.webp`
  },
  {
    title: 'Tile Connect',
    url: `https://play.google.com/store/apps/details?id=link.merge.puzzle.onnect.number`,
    starCount: '4.5',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-tile-connect-app-logo.webp`
  },
  {
    title: 'Dropping Ball',
    url: `https://play.google.com/store/apps/details?id=com.dropping.ball.jungle.android`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-dropping-ball-app-logo.webp`
  },
  {
    title: '8 Ball Pool',
    url: `https://play.google.com/store/apps/details?id=com.miniclip.eightballpool`,
    starCount: '4.5',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-eight-ball-pool-app-logo.webp`
  },
  {
    title: 'The PCH App',
    url: `https://play.google.com/store/apps/details?id=pch.apps.pchsweeps`,
    starCount: '4.25',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-the-pch-app-logo.webp`
  },
  {
    title: 'Lucky Diamond',
    url: `https://play.google.com/store/apps/details?id=com.unity.luckydiamond`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-lucky-diamond-app-logo.webp`
  },
  {
    title: 'Dragon City',
    url: `https://play.google.com/store/apps/details?id=es.socialpoint.DragonCity`,
    starCount: '4.5',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-dragon-city-app-logo.webp`
  },
  {
    title: 'Family Island',
    url: `https://play.google.com/store/apps/details?id=com.MelsoftGames.FamilyIslandFarm`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-family-island-app-logo.webp`
  },
  {
    title: 'Bubble Shooter: Panda Pop!',
    url: `https://play.google.com/store/apps/details?id=com.sgn.pandapop.gp`,
    starCount: '4.5',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-bubble-shooter-panda-pop-app-logo.webp`
  },
  {
    title: 'Solitaire TriPeak',
    url: `https://play.google.com/store/apps/details?id=com.gsn.android.tripeaks`,
    starCount: '4.25',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-solitaire-tripeak-app-logo.webp`
  },
  {
    title: 'Kick the Buddy (android)',
    url: `https://play.google.com/store/apps/details?id=com.playgendary.kickthebuddy`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-kick-the-buddy-app-logo.webp`
  },
  {
    title: 'Galaxy Attack',
    url: `https://play.google.com/store/apps/details?id=com.alien.shooter.galaxy.attack`,
    starCount: '4.25',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-galaxy-attack-app-logo.webp`
  },
  {
    title: 'Angry Birds 2',
    url: `https://play.google.com/store/apps/details?id=com.rovio.baba`,
    starCount: '4.25',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-angry-birds-2-app-logo.webp`
  },
  {
    title: 'Text Now',
    url: `https://play.google.com/store/apps/details?id=com.enflick.android.TextNow`,
    starCount: '4.25',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-text-now-app-logo.webp`
  },
  {
    title: 'Woodoku',
    url: `https://play.google.com/store/apps/details?id=com.tripledot.woodoku`,
    starCount: '4.25',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-woodoku-app-logo.webp`
  },
  {
    title: 'Happy Color',
    url: `https://play.google.com/store/apps/details?id=com.pixel.art.coloring.color.number`,
    starCount: '4.5',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-happy-color-app-logo.webp`
  },
  {
    title: 'Words with Friends',
    url: `https://play.google.com/store/apps/details?id=com.zynga.words3`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-words-with-friends-app-logo.webp`
  },
  {
    title: 'Color by Number',
    url: `https://play.google.com/store/apps/details?id=paint.by.number.pixel.art.coloring.drawing.puzzle`,
    starCount: '4.5',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-color-by-number-app-logo.webp`
  },
  {
    title: 'Match 3D',
    url: `https://play.google.com/store/apps/details?id=com.loop.match3d`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-match-3d-app-logo.webp`
  },
  {
    title: 'YAHTZEE',
    url: `https://play.google.com/store/apps/details?id=com.scopely.yux`,
    starCount: '4.25',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-yahtzee-app-logo.webp`
  },
  {
    title: 'Water Sort Puzzle',
    url: `https://play.google.com/store/apps/details?id=com.gma.water.sort.puzzle`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-water-sort-puzzle-app-logo.webp`
  },
  {
    title: 'Magic Tiles 3',
    url: `https://play.google.com/store/apps/details?id=com.youmusic.magictiles`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-magic-tiles-3-app-logo.webp`
  },
  {
    title: 'Scrabble',
    url: `https://play.google.com/store/apps/details?id=com.pieyel.scrabble`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-scrabble-app-logo.webp`
  },
  {
    title: 'Tiles Hop',
    url: `https://play.google.com/store/apps/details?id=com.amanotes.beathopper`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-tiles-hop-app-logo.webp`
  },
  {
    title: 'Gamebility',
    url: `https://play.google.com/store/apps/details?id=com.gamebility.onet`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-gamebility-app-logo.webp`
  },
  {
    title: 'High Heels',
    url: `https://play.google.com/store/apps/details?id=com.uncosoft.highheels`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-high-heels-app-logo.webp`
  },
  {
    title: 'Wood Block Puzzle',
    url: `https://play.google.puzzle/store/apps/details?id=puzzle.blockpuzzle.cube.relax`,
    starCount: '4.25',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-wood-block-puzzle-app-logo.webp`
  },
  {
    title: 'Chain Cube',
    url: `https://play.google.com/store/apps/details?id=com.colobolo.chainball`,
    starCount: '4',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-chain-cube-app-logo.webp`
  },
  {
    title: 'Solitaire',
    url: `https://play.google.com/store/apps/details?id=com.tripledot.solitaire`,
    starCount: '5',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-solitaire-app-logo.webp`
  },
  {
    title: 'Wordscapes Search',
    url: `https://play.google.com/store/apps/details?id=com.peoplefun.wordsearch`,
    starCount: '5',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-wordscapes-search-app-logo.webp`
  },
  {
    title: 'Word Collect',
    url: `https://play.google.com/store/apps/details?id=com.platinumplayer.word.addict`,
    starCount: '4.75',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-word-collect-app-logo.webp`
  },
  {
    title: 'Word Connect',
    url: `https://play.google.com/store/apps/details?id=com.wordgame.words.connect`,
    starCount: '4.5',
    image: `https://images.cm.digitalturbine.com/static/app-app_wall_items-word-connect-app-logo.webp`
  }
]
